export default "__VITE_ASSET__DESL2e_3__"